import { cn } from '~/shadcn/lib/utils'

type Props = {
  value: number
  className?: string
  integerClassName?: string
  decimalClassName?: string
  hideDecimal?: boolean
  hideCurrency?: boolean
  currency?: string
}

function CurrencyFormatter({
  value,
  className,
  integerClassName,
  decimalClassName,
  hideDecimal,
  hideCurrency,
  currency = '€',
}: Props) {
  const [integerPart = '0', decimalPart = '00'] = value
    .toFixed(2)
    .toString()
    .split('.')

  return (
    <div
      translate="no"
      className={cn('whitespace-nowrap leading-normal self-end', className)}>
      <span className={cn(integerClassName)}>
        {_formatIntegerPart(integerPart)}
      </span>
      {!hideDecimal && (
        <span className={cn(decimalClassName)}>,{decimalPart}</span>
      )}
      {!hideCurrency && <span>&nbsp;{currency}</span>}
    </div>
  )
}

function _formatIntegerPart(integerPart: string) {
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')
}

export { CurrencyFormatter }
